import React from 'react';
import { motion } from 'framer-motion';
const phases = [{
  title: 'Fase de Desinflamación',
  days: 'Días 1-7',
  desc: 'Limpiamos las señales de estrés en tu sistema.'
}, {
  title: 'Fase de Ajuste Hormonal',
  days: 'Días 8-14',
  desc: 'Introducimos el orden de nutrientes para dominar la insulina.'
}, {
  title: 'Fase de Consolidación',
  days: 'Días 15-21',
  desc: 'Activamos la quema de grasa en reposo con movimiento estratégico.'
}];
export function HowItWorks() {
  return <section className="py-16 md:py-24 bg-brand-cream" data-id="element-69">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 max-w-4xl" data-id="element-70">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-16" data-id="element-71">
          <h2 className="text-3xl md:text-4xl font-bold text-brand-text mb-4" data-id="element-72">
            Cómo funciona
          </h2>
          <p className="text-lg text-brand-text/70" data-id="element-73">
            Un proceso de 21 días diseñado para tu biología.
          </p>
        </motion.div>

        <div className="relative" data-id="element-74">
          {/* Connecting line */}
          <div className="absolute left-[27px] md:left-1/2 top-0 bottom-0 w-0.5 bg-brand-terracotta/20 md:-translate-x-1/2" data-id="element-75" />

          <div className="space-y-12 relative" data-id="element-76">
            {phases.map((phase, index) => <motion.div key={index} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.5,
            delay: index * 0.2
          }} className={`flex flex-col md:flex-row items-start md:items-center gap-8 ${index % 2 === 0 ? 'md:flex-row-reverse' : ''}`} data-id="element-77">
                <div className={`flex-1 w-full md:w-1/2 ${index % 2 === 0 ? 'md:text-left' : 'md:text-right'} pl-16 md:pl-0`} data-id="element-78">
                  <div className="bg-white p-6 rounded-2xl shadow-sm border border-brand-accent/30 inline-block w-full" data-id="element-79">
                    <span className="text-brand-terracotta font-semibold text-sm tracking-wider uppercase mb-2 block" data-id="element-80">
                      {phase.days}
                    </span>
                    <h3 className="text-xl font-bold text-brand-text mb-2" data-id="element-81">
                      {phase.title}
                    </h3>
                    <p className="text-brand-text/70" data-id="element-82">{phase.desc}</p>
                  </div>
                </div>

                <div className="absolute left-0 md:left-1/2 md:-translate-x-1/2 w-14 h-14 rounded-full bg-brand-terracotta text-white flex items-center justify-center font-bold text-xl shadow-lg border-4 border-brand-cream z-10" data-id="element-83">
                  {index + 1}
                </div>

                <div className="hidden md:block flex-1 w-1/2" data-id="element-84" />
              </motion.div>)}
          </div>
        </div>
      </div>
    </section>;
}